import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard, HRAuthGuard } from 'src/auth/guard';

import { usePathname } from '../hooks';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------
const IndexPage = lazy(() => import('src/pages/dashboard/one'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export function getDashboardRoutes(): RouteObject[] {
  const config = getConfig();

  return [
    {
      path: 'dashboard',
      element: config.auth.skip ? (
        dashboardLayout()
      ) : (
        <AuthGuard>
          <HRAuthGuard>{dashboardLayout()}</HRAuthGuard>
        </AuthGuard>
      ),
      children: [{ element: <IndexPage />, index: true }],
    },
  ];
}
